export const LINKEDIN_INDUSTRY_CODES = [
  "Abrasives and Nonmetallic Minerals Manufacturing",
  "Accessible Architecture and Design",
  "Accessible Hardware Manufacturing",
  "Accommodation Services",
  "Accounting",
  "Administration of Justice",
  "Administrative and Support Services",
  "Advertising Services",
  "Agricultural Chemical Manufacturing",
  "Agriculture, Construction, Mining Machinery Manufacturing",
  "Air, Water, and Waste Program Management",
  "Airlines and Aviation",
  "Alternative Dispute Resolution",
  "Alternative Fuel Vehicle Manufacturing",
  "Alternative Medicine",
  "Ambulance Services",
  "Amusement Parks and Arcades",
  "Animal Feed Manufacturing",
  "Animation",
  "Animation and Post-production",
  "Apparel Manufacturing",
  "Apparel and Fashion",
  "Appliances, Electrical, and Electronics Manufacturing",
  "Architectural and Structural Metal Manufacturing",
  "Architecture and Planning",
  "Armed Forces",
  "Artificial Rubber and Synthetic Fiber Manufacturing",
  "Artists and Writers",
  "Arts and Crafts",
  "Audio and Video Equipment Manufacturing",
  "Automation Machinery Manufacturing",
  "Automotive",
  "Aviation & Aerospace",
  "Aviation and Aerospace Component Manufacturing",
  "Baked Goods Manufacturing",
  "Banking",
  "Bars, Taverns, and Nightclubs",
  "Bed-and-Breakfasts, Hostels, Homestays",
  "Beverage Manufacturing",
  "Biomass Electric Power Generation",
  "Biotechnology",
  "Biotechnology Research",
  "Blockchain Services",
  "Blogs",
  "Boilers, Tanks, and Shipping Container Manufacturing",
  "Book Publishing",
  "Book and Periodical Publishing",
  "Breweries",
  "Broadcast Media Production and Distribution",
  "Building Construction",
  "Building Equipment Contractors",
  "Building Finishing Contractors",
  "Building Materials",
  "Building Structure and Exterior Contractors",
  "Business Consulting and Services",
  "Business Content",
  "Business Intelligence Platforms",
  "Business Supplies and Equipment",
  "Cable and Satellite Programming",
  "Capital Markets",
  "Caterers",
  "Chemical Manufacturing",
  "Chemical Raw Materials Manufacturing",
  "Child Day Care Services",
  "Chiropractors",
  "Circuses and Magic Shows",
  "Civic and Social Organizations",
  "Civil Engineering",
  "Claims Adjusting, Actuarial Services",
  "Clay and Refractory Products Manufacturing",
  "Climate Data and Analytics",
  "Climate Technology Product Manufacturing",
  "Coal Mining",
  "Collection Agencies",
  "Commercial Real Estate",
  "Commercial and Industrial Equipment Rental",
  "Commercial and Industrial Machinery Maintenance",
  "Commercial and Service Industry Machinery Manufacturing",
  "Communications Equipment Manufacturing",
  "Community Development and Urban Planning",
  "Community Services",
  "Computer Games",
  "Computer Hardware",
  "Computer Hardware Manufacturing",
  "Computer Networking",
  "Computer Networking Products",
  "Computer and Network Security",
  "Computers and Electronics Manufacturing",
  "Conservation Programs",
  "Construction",
  "Construction Hardware Manufacturing",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Goods Rental",
  "Consumer Services",
  "Correctional Institutions",
  "Cosmetics",
  "Cosmetology and Barber Schools",
  "Courts of Law",
  "Credit Intermediation",
  "Cutlery and Handtool Manufacturing",
  "Dairy",
  "Dairy Product Manufacturing",
  "Dance Companies",
  "Data Infrastructure and Analytics",
  "Data Security Software Products",
  "Defense & Space",
  "Defense and Space Manufacturing",
  "Dentists",
  "Design",
  "Design Services",
  "Desktop Computing Software Products",
  "Digital Accessibility Services",
  "Distilleries",
  "E-Learning",
  "E-Learning Providers",
  "Economic Programs",
  "Education",
  "Education Administration Programs",
  "Education Management",
  "Electric Lighting Equipment Manufacturing",
  "Electric Power Generation",
  "Electric Power Transmission, Control, and Distribution",
  "Electrical Equipment Manufacturing",
  "Electronic and Precision Equipment Maintenance",
  "Embedded Software Products",
  "Emergency and Relief Services",
  "Engineering Services",
  "Engines and Power Transmission Equipment Manufacturing",
  "Entertainment",
  "Entertainment Providers",
  "Environmental Quality Programs",
  "Environmental Services",
  "Equipment Rental Services",
  "Events Services",
  "Executive Offices",
  "Executive Search Services",
  "Fabricated Metal Products",
  "Facilities Services",
  "Family Planning Centers",
  "Farming",
  "Farming, Ranching, Forestry",
  "Fashion Accessories Manufacturing",
  "Financial Services",
  "Fine Art",
  "Fine Arts Schools",
  "Fire Protection",
  "Fisheries",
  "Flight Training",
  "Food & Beverages",
  "Food Production",
  "Food and Beverage Manufacturing",
  "Food and Beverage Retail",
  "Food and Beverage Services",
  "Footwear Manufacturing",
  "Footwear and Leather Goods Repair",
  "Forestry and Logging",
  "Fossil Fuel Electric Power Generation",
  "Freight and Package Transportation",
  "Fruit and Vegetable Preserves Manufacturing",
  "Fuel Cell Manufacturing",
  "Fundraising",
  "Funds and Trusts",
  "Furniture",
  "Furniture and Home Furnishings Manufacturing",
  "Gambling Facilities and Casinos",
  "Geothermal Electric Power Generation",
  "Glass Product Manufacturing",
  "Glass, Ceramics and Concrete Manufacturing",
  "Golf Courses and Country Clubs",
  "Government Administration",
  "Government Relations",
  "Government Relations Services",
  "Graphic Design",
  "Ground Passenger Transportation",
  "HVAC and Refrigeration Equipment Manufacturing",
  "Health and Human Services",
  "Health, Wellness and Fitness",
  "Higher Education",
  "Highway, Street, and Bridge Construction",
  "Historical Sites",
  "Holding Companies",
  "Home Health Care Services",
  "Horticulture",
  "Hospitality",
  "Hospitals",
  "Hospitals and Health Care",
  "Hotels and Motels",
  "Household Appliance Manufacturing",
  "Household Services",
  "Household and Institutional Furniture Manufacturing",
  "Housing Programs",
  "Housing and Community Development",
  "Human Resources",
  "Human Resources Services",
  "Hydroelectric Power Generation",
  "IT Services and IT Consulting",
  "IT System Custom Software Development",
  "IT System Data Services",
  "IT System Design Services",
  "IT System Installation and Disposal",
  "IT System Operations and Maintenance",
  "IT System Testing and Evaluation",
  "IT System Training and Support",
  "Import and Export",
  "Individual and Family Services",
  "Industrial Automation",
  "Industrial Machinery Manufacturing",
  "Industry Associations",
  "Information Services",
  "Information Technology and Services",
  "Insurance",
  "Insurance Agencies and Brokerages",
  "Insurance Carriers",
  "Insurance and Employee Benefit Funds",
  "Interior Design",
  "International Affairs",
  "International Trade and Development",
  "Internet Marketplace Platforms",
  "Internet News",
  "Internet Publishing",
  "Interurban and Rural Bus Services",
  "Investment Advice",
  "Investment Banking",
  "Investment Management",
  "Janitorial Services",
  "Landscaping Services",
  "Language Schools",
  "Laundry and Drycleaning Services",
  "Law Enforcement",
  "Law Practice",
  "Leasing Non-residential Real Estate",
  "Leasing Residential Real Estate",
  "Leather Product Manufacturing",
  "Legal Services",
  "Legislative Offices",
  "Leisure, Travel & Tourism",
  "Libraries",
  "Lime and Gypsum Products Manufacturing",
  "Loan Brokers",
  "Luxury Goods and Jewelry",
  "Machinery Manufacturing",
  "Magnetic and Optical Media Manufacturing",
  "Manufacturing",
  "Maritime",
  "Maritime Transportation",
  "Market Research",
  "Marketing Services",
  "Mattress and Blinds Manufacturing",
  "Measuring and Control Instrument Manufacturing",
  "Meat Products Manufacturing",
  "Mechanical or Industrial Engineering",
  "Media & Telecommunications",
  "Media Production",
  "Medical Devices",
  "Medical Equipment Manufacturing",
  "Medical Practices",
  "Medical and Diagnostic Laboratories",
  "Mental Health Care",
  "Metal Ore Mining",
  "Metal Treatments",
  "Metal Valve, Ball, and Roller Manufacturing",
  "Metalworking Machinery Manufacturing",
  "Military and International Affairs",
  "Mining",
  "Mobile Computing Software Products",
  "Mobile Food Services",
  "Mobile Gaming Apps",
  "Motor Vehicle Manufacturing",
  "Motor Vehicle Parts Manufacturing",
  "Movies and Sound Recording",
  "Movies, Videos and Sound",
  "Museums",
  "Museums, Historical Sites, and Zoos",
  "Music",
  "Musicians",
  "Nanotechnology Research",
  "Natural Gas Distribution",
  "Natural Gas Extraction",
  "Newspaper Publishing",
  "Non-profit Organization Management",
  "Non-profit Organizations",
  "Nonmetallic Mineral Mining",
  "Nonresidential Building Construction",
  "Nuclear Electric Power Generation",
  "Nursing Homes and Residential Care Facilities",
  "Office Administration",
  "Office Furniture and Fixtures Manufacturing",
  "Oil Extraction",
  "Oil and Coal Product Manufacturing",
  "Oil and Gas",
  "Oil, Gas, and Mining",
  "Online Audio and Video Media",
  "Online Media",
  "Online and Mail Order Retail",
  "Operations Consulting",
  "Optometrists",
  "Outpatient Care Centers",
  "Outsourcing and Offshoring Consulting",
  "Outsourcing/Offshoring",
  "Packaging and Containers",
  "Packaging and Containers Manufacturing",
  "Paint, Coating, and Adhesive Manufacturing",
  "Paper and Forest Product Manufacturing",
  "Paper and Forest Products",
  "Pension Funds",
  "Performing Arts",
  "Performing Arts and Spectator Sports",
  "Periodical Publishing",
  "Personal Care Product Manufacturing",
  "Personal Care Services",
  "Personal and Laundry Services",
  "Pet Services",
  "Pharmaceutical Manufacturing",
  "Philanthropic Fundraising Services",
  "Philanthropy",
  "Photography",
  "Physical, Occupational and Speech Therapists",
  "Physicians",
  "Pipeline Transportation",
  "Plastics Manufacturing",
  "Plastics and Rubber Product Manufacturing",
  "Political Organizations",
  "Postal Services",
  "Primary Metal Manufacturing",
  "Primary and Secondary Education",
  "Printing Services",
  "Professional Organizations",
  "Professional Services",
  "Professional Training and Coaching",
  "Program Development",
  "Public Assistance Programs",
  "Public Health",
  "Public Policy",
  "Public Policy Offices",
  "Public Relations and Communications Services",
  "Public Safety",
  "Racetracks",
  "Radio and Television Broadcasting",
  "Rail Transportation",
  "Railroad Equipment Manufacturing",
  "Ranching",
  "Ranching and Fisheries",
  "Real Estate",
  "Real Estate Agents and Brokers",
  "Real Estate and Equipment Rental Services",
  "Recreational Facilities",
  "Regenerative Design",
  "Religious Institutions",
  "Renewable Energy Equipment Manufacturing",
  "Renewable Energy Power Generation",
  "Renewable Energy Semiconductor Manufacturing",
  "Renewables & Environment",
  "Repair and Maintenance",
  "Research",
  "Research Services",
  "Residential Building Construction",
  "Restaurants",
  "Retail",
  "Retail Apparel and Fashion",
  "Retail Appliances, Electrical, and Electronic Equipment",
  "Retail Art Dealers",
  "Retail Art Supplies",
  "Retail Books and Printed News",
  "Retail Building Materials and Garden Equipment",
  "Retail Florists",
  "Retail Furniture and Home Furnishings",
  "Retail Gasoline",
  "Retail Groceries",
  "Retail Health and Personal Care Products",
  "Retail Luxury Goods and Jewelry",
  "Retail Motor Vehicles",
  "Retail Musical Instruments",
  "Retail Office Equipment",
  "Retail Office Supplies and Gifts",
  "Retail Pharmacies",
  "Retail Recyclable Materials & Used Merchandise",
  "Reupholstery and Furniture Repair",
  "Robot Manufacturing",
  "Robotics Engineering",
  "Rubber Products Manufacturing",
  "Satellite Telecommunications",
  "Savings Institutions",
  "School and Employee Bus Services",
  "Seafood Product Manufacturing",
  "Secretarial Schools",
  "Securities and Commodity Exchanges",
  "Security Guards and Patrol Services",
  "Security Systems Services",
  "Security and Investigations",
  "Semiconductor Manufacturing",
  "Semiconductors",
  "Services for Renewable Energy",
  "Services for the Elderly and Disabled",
  "Sheet Music Publishing",
  "Shipbuilding",
  "Shuttles and Special Needs Transportation Services",
  "Sightseeing Transportation",
  "Skiing Facilities",
  "Smart Meter Manufacturing",
  "Soap and Cleaning Product Manufacturing",
  "Social Networking Platforms",
  "Software Development",
  "Solar Electric Power Generation",
  "Sound Recording",
  "Space Research and Technology",
  "Specialty Trade Contractors",
  "Spectator Sports",
  "Sporting Goods",
  "Sporting Goods Manufacturing",
  "Sports Teams and Clubs",
  "Sports and Recreation Instruction",
  "Spring and Wire Product Manufacturing",
  "Staffing and Recruiting",
  "Steam and Air-Conditioning Supply",
  "Strategic Management Services",
  "Subdivision of Land",
  "Sugar and Confectionery Product Manufacturing",
  "Surveying and Mapping Services",
  "Taxi and Limousine Services",
  "Technical and Vocational Training",
  "Technology, Information and Internet",
  "Technology, Information and Media",
  "Telecommunications",
  "Telecommunications Carriers",
  "Telephone Call Centers",
  "Temporary Help Services",
  "Textile Manufacturing",
  "Theater Companies",
  "Think Tanks",
  "Tobacco",
  "Tobacco Manufacturing",
  "Translation and Localization",
  "Transportation Equipment Manufacturing",
  "Transportation Programs",
  "Transportation, Logistics, Supply Chain and Storage",
  "Transportation/Trucking/Railroad",
  "Travel Arrangements",
  "Truck Transportation",
  "Trusts and Estates",
  "Turned Products and Fastener Manufacturing",
  "Urban Transit Services",
  "Utilities",
  "Utilities Administration",
  "Utility System Construction",
  "Vehicle Repair and Maintenance",
  "Venture Capital and Private Equity Principals",
  "Veterinary",
  "Veterinary Services",
  "Vocational Rehabilitation Services",
  "Warehousing",
  "Warehousing and Storage",
  "Waste Collection",
  "Waste Treatment and Disposal",
  "Water Supply and Irrigation Systems",
  "Water, Waste, Steam, and Air Conditioning Services",
  "Wellness and Fitness Services",
  "Wholesale",
  "Wholesale Alcoholic Beverages",
  "Wholesale Apparel and Sewing Supplies",
  "Wholesale Appliances, Electrical, and Electronics",
  "Wholesale Building Materials",
  "Wholesale Chemical and Allied Products",
  "Wholesale Computer Equipment",
  "Wholesale Drugs and Sundries",
  "Wholesale Food and Beverage",
  "Wholesale Footwear",
  "Wholesale Furniture and Home Furnishings",
  "Wholesale Hardware, Plumbing, Heating Equipment",
  "Wholesale Import and Export",
  "Wholesale Luxury Goods and Jewelry",
  "Wholesale Machinery",
  "Wholesale Metals and Minerals",
  "Wholesale Motor Vehicles and Parts",
  "Wholesale Paper Products",
  "Wholesale Petroleum and Petroleum Products",
  "Wholesale Photography Equipment and Supplies",
  "Wholesale Raw Farm Products",
  "Wholesale Recyclable Materials",
  "Wind Electric Power Generation",
  "Wine and Spirits",
  "Wineries",
  "Wireless Services",
  "Women's Handbag Manufacturing",
  "Wood Product Manufacturing",
  "Writing and Editing",
  "Zoos and Botanical Gardens"
]

export const OS_INDUSTRIES = {
  all: "All",
  AEROSPACE_AND_DEFENSE: "AEROSPACE & DEFENSE",
  AIRLINE: "AIRLINE",
  ASSET_MANAGEMENT: "ASSET MANAGEMENT",
  AUTOMOTIVE_OEM: "AUTOMOTIVE OEM",
  BROKERAGE: "BROKERAGE",
  CHEMICALS_AND_FERTILISERS: "CHEMICALS & FERTILISERS",
  CPG: "CPG",
  EDUCATION: "EDUCATION",
  EMERGENCY_SERVICES: "EMERGENCY SERVICES",
  FINANCIAL_SERVICES: "FINANCIAL SERVICES",
  GOVERNMENT_AND_PUBLIC_ADMINISTRATION: "GOVERNMENT & PUBLIC ADMINISTRATION",
  HEALTHCARE_PROVIDERS: "HEALTHCARE PROVIDERS",
  INDUSTRIAL: "INDUSTRIAL",
  INSURANCE: "INSURANCE",
  ISV: "ISV",
  LAW_ENFORCEMENT: "LAW ENFORCEMENT",
  LIFE_SCIENCES: "LIFE SCIENCES",
  LOGISTICS: "LOGISTICS",
  MEDIA: "MEDIA",
  MEDICAL_DEVICES: "MEDICAL DEVICES",
  METALS_AND_MINING: "METALS & MINING",
  OIL_AND_GAS: "OIL & GAS",
  PROFESSIONAL_SERVICES_PROVIDER: "PROFESSIONAL SERVICES PROVIDER",
  PUBLISHING: "PUBLISHING",
  RETAIL: "RETAIL",
  SEMICONDUCTOR: "SEMICONDUCTOR",
  TELECOM_OEM: "TELECOM & OEM",
  TELECOM_OPERATORS: "TELECOM & OPERATORS",
  TRANSPORTATION: "TRANSPORTATION",
  TRAVEL_TOURS_HOSPITALITY: "TRAVEL & TOURS & HOSPITALITY",
  UTILITIES: "UTILITIES",
  WAGERING: "WAGERING"
}

export const OS_INDUSTRIES_OPTIONS = Object.entries(OS_INDUSTRIES).map(
  ([key, value]) => ({
    label: value,
    value: key
  })
)

// Maps the outbound-agent ICP setup wizard's industry slugs
// (icp-form.tsx's INDUSTRY_OPTIONS values, e.g. "bfsi") to the backend's
// `primary_usecase_type` enum code(s) — mirrors
// api-getorbitx/controllers/outbound-orchestrator.js's ICP_TO_OS_INDUSTRIES
// exactly. A matched account's raw `industry` field on the wire is either
// one of these enum codes (uploaded/subscribed accounts) or
// OS_INDUSTRIES[code] (hot_accounts-discovered ones) — never the frontend's
// own slug — so this table is what lets the Accounts-tab industry filter
// match real account data back to the slug the user selected in setup.
export const ICP_INDUSTRY_TO_OS_INDUSTRIES: Record<string, string[]> = {
  manufacturing: ["INDUSTRIAL"],
  bfsi: ["FINANCIAL_SERVICES", "ASSET_MANAGEMENT", "BROKERAGE"],
  pharma: ["LIFE_SCIENCES"],
  energy: ["OIL_AND_GAS", "UTILITIES"],
  retail: ["RETAIL"],
  telecom: ["TELECOM_OEM", "TELECOM_OPERATORS"],
  healthcare: ["HEALTHCARE_PROVIDERS", "MEDICAL_DEVICES"],
  technology: ["ISV", "SEMICONDUCTOR"],
  cpg: ["CPG"],
  automotive: ["AUTOMOTIVE_OEM"],
  aerospace: ["AEROSPACE_AND_DEFENSE"],
  insurance: ["INSURANCE"],
  media: ["MEDIA", "PUBLISHING"],
  logistics: ["LOGISTICS", "TRANSPORTATION"],
  chemicals: ["CHEMICALS_AND_FERTILISERS"],
  education: ["EDUCATION"],
  metals_mining: ["METALS_AND_MINING"],
  professional_services: ["PROFESSIONAL_SERVICES_PROVIDER"],
  public_sector: ["GOVERNMENT_AND_PUBLIC_ADMINISTRATION"],
  semiconductor: ["SEMICONDUCTOR"],
  travel_hospitality: ["TRAVEL_TOURS_HOSPITALITY", "AIRLINE"]
}

export const LINKEDIN_COUNTRIES = [
  "United States",
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Caribbean Nations",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Cote D’Ivoire (Ivory Coast)",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Federated States of Micronesia",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea",
  "Korea (North)",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovak Republic",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City State (Holy See)",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Other"
].map((country) => ({
  labelKey: `country_${country
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/['’]/g, "")
    .replace(/\(.*?\)/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")}`,
  label: country,
  value: country
}))

// export const LINKEDIN_INDUSTRY_OPTIONS = [
//   {
//     title: 'Accommodation and Hospitality',
//     value: 'Accommodation and Hospitality',
//     key: 'Accommodation and Hospitality',
//     children: [
//       {
//         title: 'Accommodation Services',
//         value: 'Accommodation Services',
//         key: 'Accommodation Services',
//       },
//       {
//         title: 'Food and Beverage Services',
//         value: 'Food and Beverage Services',
//         key: 'Food and Beverage Services',
//       },
//       {
//         title: 'Bars, Taverns, and Nightclubs',
//         value: 'Bars, Taverns, and Nightclubs',
//         key: 'Bars, Taverns, and Nightclubs',
//       },
//       { title: 'Caterers', value: 'Caterers', key: 'Caterers' },
//       {
//         title: 'Mobile Food Services',
//         value: 'Mobile Food Services',
//         key: 'Mobile Food Services',
//       },
//       { title: 'Restaurants', value: 'Restaurants', key: 'Restaurants' },
//       { title: 'Hospitality', value: 'Hospitality', key: 'Hospitality' },
//       {
//         title: 'Bed-and-Breakfasts, Hostels, Homestays',
//         value: 'Bed-and-Breakfasts, Hostels, Homestays',
//         key: 'Bed-and-Breakfasts, Hostels, Homestays',
//       },
//       {
//         title: 'Hotels and Motels',
//         value: 'Hotels and Motels',
//         key: 'Hotels and Motels',
//       },
//     ],
//   },
//   {
//     title: 'Administrative and Support Services',
//     value: 'Administrative and Support Services',
//     key: 'Administrative and Support Services 1',
//     children: [
//       {
//         title: 'Administrative and Support Services',
//         value: 'Administrative and Support Services',
//         key: 'Administrative and Support Services',
//       },
//       {
//         title: 'Collection Agencies',
//         value: 'Collection Agencies',
//         key: 'Collection Agencies',
//       },
//       {
//         title: 'Events Services',
//         value: 'Events Services',
//         key: 'Events Services',
//       },
//       {
//         title: 'Facilities Services',
//         value: 'Facilities Services',
//         key: 'Facilities Services',
//       },
//       {
//         title: 'Janitorial Services',
//         value: 'Janitorial Services',
//         key: 'Janitorial Services',
//       },
//       {
//         title: 'Landscaping Services',
//         value: 'Landscaping Services',
//         key: 'Landscaping Services',
//       },
//       { title: 'Fundraising', value: 'Fundraising', key: 'Fundraising' },
//       {
//         title: 'Office Administration',
//         value: 'Office Administration',
//         key: 'Office Administration',
//       },
//       {
//         title: 'Security and Investigations',
//         value: 'Security and Investigations',
//         key: 'Security and Investigations',
//         children: [
//           {
//             title: 'Security Guards and Patrol Services',
//             value: 'Security Guards and Patrol Services',
//             key: 'Security Guards and Patrol Services',
//           },
//           {
//             title: 'Security Systems Services',
//             value: 'Security Systems Services',
//             key: 'Security Systems Services',
//           },
//         ],
//       },
//       {
//         title: 'Staffing and Recruiting',
//         value: 'Staffing and Recruiting',
//         key: 'Staffing and Recruiting',
//         children: [
//           {
//             title: 'Executive Search Services',
//             value: 'Executive Search Services',
//             key: 'Executive Search Services',
//           },
//           {
//             title: 'Temporary Help Services',
//             value: 'Temporary Help Services',
//             key: 'Temporary Help Services',
//           },
//         ],
//       },
//       {
//         title: 'Telephone Call Centers',
//         value: 'Telephone Call Centers',
//         key: 'Telephone Call Centers',
//       },
//       {
//         title: 'Translation and Localization',
//         value: 'Translation and Localization',
//         key: 'Translation and Localization',
//       },
//       {
//         title: 'Travel Arrangements',
//         value: 'Travel Arrangements',
//         key: 'Travel Arrangements',
//       },
//       {
//         title: 'Writing and Editing',
//         value: 'Writing and Editing',
//         key: 'Writing and Editing',
//       },
//     ],
//   },
//   {
//     title: 'Construction',
//     value: 'Construction',
//     key: 'Construction 1',
//     children: [
//       {
//         title: 'Construction',
//         value: 'Construction',
//         key: 'Construction',
//       },
//       {
//         title: 'Building Construction',
//         value: 'Building Construction',
//         key: 'Building Construction',
//         children: [
//           {
//             title: 'Nonresidential Building Construction',
//             value: 'Nonresidential Building Construction',
//             key: 'Nonresidential Building Construction',
//           },
//           {
//             title: 'Residential Building Construction',
//             value: 'Residential Building Construction',
//             key: 'Residential Building Construction',
//           },
//         ],
//       },
//       {
//         title: 'Civil Engineering',
//         value: 'Civil Engineering',
//         key: 'Civil Engineering',
//         children: [
//           {
//             title: 'Highway, Street, and Bridge Construction',
//             value: 'Highway, Street, and Bridge Construction',
//             key: 'Highway, Street, and Bridge Construction',
//           },
//           {
//             title: 'Subdivision of Land',
//             value: 'Subdivision of Land',
//             key: 'Subdivision of Land',
//           },
//           {
//             title: 'Utility System Construction',
//             value: 'Utility System Construction',
//             key: 'Utility System Construction',
//           },
//         ],
//       },
//       {
//         title: 'Specialty Trade Contractors',
//         value: 'Specialty Trade Contractors',
//         key: 'Specialty Trade Contractors',
//         children: [
//           {
//             title: 'Building Equipment Contractors',
//             value: 'Building Equipment Contractors',
//             key: 'Building Equipment Contractors',
//           },
//           {
//             title: 'Building Finishing Contractors',
//             value: 'Building Finishing Contractors',
//             key: 'Building Finishing Contractors',
//           },
//           {
//             title: 'Building Structure and Exterior Contractors',
//             value: 'Building Structure and Exterior Contractors',
//             key: 'Building Structure and Exterior Contractors',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Consumer Services',
//     value: 'Consumer Services',
//     key: 'Consumer Services',
//     children: [
//       {
//         title: 'Civic and Social Organizations',
//         value: 'Civic and Social Organizations',
//         key: 'Civic and Social Organizations',
//         children: [
//           {
//             title: 'Industry Associations',
//             value: 'Industry Associations',
//             key: 'Industry Associations',
//           },
//           {
//             title: 'Political Organizations',
//             value: 'Political Organizations',
//             key: 'Political Organizations',
//           },
//           {
//             title: 'Professional Organizations',
//             value: 'Professional Organizations',
//             key: 'Professional Organizations',
//           },
//         ],
//       },
//       {
//         title: 'Household Services',
//         value: 'Household Services',
//         key: 'Household Services',
//         children: [
//           {
//             title: 'Personal and Laundry Services',
//             value: 'Personal and Laundry Services',
//             key: 'Personal and Laundry Services',
//             children: [
//               {
//                 title: 'Laundry and Drycleaning Services',
//                 value: 'Laundry and Drycleaning Services',
//                 key: 'Laundry and Drycleaning Services',
//               },
//               {
//                 title: 'Personal Care Services',
//                 value: 'Personal Care Services',
//                 key: 'Personal Care Services',
//               },
//               {
//                 title: 'Pet Services',
//                 value: 'Pet Services',
//                 key: 'Pet Services',
//               },
//             ],
//           },
//           {
//             title: 'Philanthropic Fundraising Services',
//             value: 'Philanthropic Fundraising Services',
//             key: 'Philanthropic Fundraising Services',
//           },
//           {
//             title: 'Religious Institutions',
//             value: 'Religious Institutions',
//             key: 'Religious Institutions',
//           },
//         ],
//       },
//       {
//         title: 'Repair and Maintenance',
//         value: 'Repair and Maintenance',
//         key: 'Repair and Maintenance',
//         children: [
//           {
//             title: 'Commercial and Industrial Machinery Maintenance',
//             value: 'Commercial and Industrial Machinery Maintenance',
//             key: 'Commercial and Industrial Machinery Maintenance',
//           },
//           {
//             title: 'Electronic and Precision Equipment Maintenance',
//             value: 'Electronic and Precision Equipment Maintenance',
//             key: 'Electronic and Precision Equipment Maintenance',
//           },
//           {
//             title: 'Footwear and Leather Goods Repair',
//             value: 'Footwear and Leather Goods Repair',
//             key: 'Footwear and Leather Goods Repair',
//           },
//           {
//             title: 'Reupholstery and Furniture Repair',
//             value: 'Reupholstery and Furniture Repair',
//             key: 'Reupholstery and Furniture Repair',
//           },
//           {
//             title: 'Vehicle Repair and Maintenance',
//             value: 'Vehicle Repair and Maintenance',
//             key: 'Vehicle Repair and Maintenance',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Education',
//     value: 'Education',
//     key: 'Education',
//     children: [
//       {
//         title: 'E-Learning Providers',
//         value: 'E-Learning Providers',
//         key: 'E-Learning Providers',
//       },
//       {
//         title: 'Higher Education',
//         value: 'Higher Education',
//         key: 'Higher Education',
//       },
//       {
//         title: 'Primary and Secondary Education',
//         value: 'Primary and Secondary Education',
//         key: 'Primary and Secondary Education',
//       },
//       {
//         title: 'Professional Training and Coaching',
//         value: 'Professional Training and Coaching',
//         key: 'Professional Training and Coaching',
//       },
//       {
//         title: 'Technical and Vocational Training',
//         value: 'Technical and Vocational Training',
//         key: 'Technical and Vocational Training',
//         children: [
//           {
//             title: 'Cosmetology and Barber Schools',
//             value: 'Cosmetology and Barber Schools',
//             key: 'Cosmetology and Barber Schools',
//           },
//           {
//             title: 'Fine Arts Schools',
//             value: 'Fine Arts Schools',
//             key: 'Fine Arts Schools',
//           },
//           {
//             title: 'Flight Training',
//             value: 'Flight Training',
//             key: 'Flight Training',
//           },
//           {
//             title: 'Language Schools',
//             value: 'Language Schools',
//             key: 'Language Schools',
//           },
//           {
//             title: 'Secretarial Schools',
//             value: 'Secretarial Schools',
//             key: 'Secretarial Schools',
//           },
//           {
//             title: 'Sports and Recreation Instruction',
//             value: 'Sports and Recreation Instruction',
//             key: 'Sports and Recreation Instruction',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Entertainment and Arts',
//     value: 'Entertainment and Arts',
//     key: 'Entertainment and Arts',
//     children: [
//       {
//         title: 'Entertainment Providers',
//         value: 'Entertainment Providers',
//         key: 'Entertainment Providers',
//       },
//       {
//         title: 'Artists and Writers',
//         value: 'Artists and Writers',
//         key: 'Artists and Writers',
//       },
//       {
//         title: 'Museums, Historical Sites, and Zoos',
//         value: 'Museums, Historical Sites, and Zoos',
//         key: 'Museums, Historical Sites, and Zoos',
//         children: [
//           {
//             title: 'Historical Sites',
//             value: 'Historical Sites',
//             key: 'Historical Sites',
//           },
//           {
//             title: 'Museums',
//             value: 'Museums',
//             key: 'Museums',
//           },
//           {
//             title: 'Zoos and Botanical Gardens',
//             value: 'Zoos and Botanical Gardens',
//             key: 'Zoos and Botanical Gardens',
//           },
//         ],
//       },
//       {
//         title: 'Musicians',
//         value: 'Musicians',
//         key: 'Musicians',
//       },
//       {
//         title: 'Performing Arts and Spectator Sports',
//         value: 'Performing Arts and Spectator Sports',
//         key: 'Performing Arts and Spectator Sports',
//         children: [
//           {
//             title: 'Circuses and Magic Shows',
//             value: 'Circuses and Magic Shows',
//             key: 'Circuses and Magic Shows',
//           },
//           {
//             title: 'Dance Companies',
//             value: 'Dance Companies',
//             key: 'Dance Companies',
//           },
//           {
//             title: 'Performing Arts',
//             value: 'Performing Arts',
//             key: 'Performing Arts',
//           },
//           {
//             title: 'Spectator Sports',
//             value: 'Spectator Sports',
//             key: 'Spectator Sports',
//           },
//           {
//             title: 'Racetracks',
//             value: 'Racetracks',
//             key: 'Racetracks',
//           },
//           {
//             title: 'Sports Teams and Clubs',
//             value: 'Sports Teams and Clubs',
//             key: 'Sports Teams and Clubs',
//           },
//           {
//             title: 'Theater Companies',
//             value: 'Theater Companies',
//             key: 'Theater Companies',
//           },
//         ],
//       },
//       {
//         title: 'Recreational Facilities',
//         value: 'Recreational Facilities',
//         key: 'Recreational Facilities',
//         children: [
//           {
//             title: 'Amusement Parks and Arcades',
//             value: 'Amusement Parks and Arcades',
//             key: 'Amusement Parks and Arcades',
//           },
//           {
//             title: 'Gambling Facilities and Casinos',
//             value: 'Gambling Facilities and Casinos',
//             key: 'Gambling Facilities and Casinos',
//           },
//           {
//             title: 'Golf Courses and Country Clubs',
//             value: 'Golf Courses and Country Clubs',
//             key: 'Golf Courses and Country Clubs',
//           },
//           {
//             title: 'Skiing Facilities',
//             value: 'Skiing Facilities',
//             key: 'Skiing Facilities',
//           },
//           {
//             title: 'Wellness and Fitness Services',
//             value: 'Wellness and Fitness Services',
//             key: 'Wellness and Fitness Services',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Utilities',
//     value: 'Utilities',
//     key: 'Utilities 1',
//     children: [
//       {
//         title: 'Electric Utilities',
//         value: 'Electric Utilities',
//         key: 'Electric Utilities',
//       },
//       {
//         title: 'Utility System Construction',
//         value: 'Utility System Construction',
//         key: 'Utility System Construction',
//       },
//     ],
//   },
//   {
//     title: 'Farming, Ranching, Forestry',
//     value: 'Farming, Ranching, Forestry',
//     key: 'Farming, Ranching, Forestry',
//     children: [
//       {
//         title: 'Farming',
//         value: 'Farming',
//         key: 'Farming',
//       },
//       {
//         title: 'Horticulture',
//         value: 'Horticulture',
//         key: 'Horticulture',
//       },
//       {
//         title: 'Forestry and Logging',
//         value: 'Forestry and Logging',
//         key: 'Forestry and Logging',
//       },
//       {
//         title: 'Ranching and Fisheries',
//         value: 'Ranching and Fisheries',
//         key: 'Ranching and Fisheries',
//         children: [
//           {
//             title: 'Fisheries',
//             value: 'Fisheries',
//             key: 'Fisheries',
//           },
//           {
//             title: 'Ranching',
//             value: 'Ranching',
//             key: 'Ranching',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Financial Services',
//     value: 'Financial Services',
//     key: 'Financial Services',
//     children: [
//       {
//         title: 'Capital Markets',
//         value: 'Capital Markets',
//         key: 'Capital Markets',
//         children: [
//           {
//             title: 'Investment Advice',
//             value: 'Investment Advice',
//             key: 'Investment Advice',
//           },
//           {
//             title: 'Investment Banking',
//             value: 'Investment Banking',
//             key: 'Investment Banking',
//           },
//           {
//             title: 'Investment Management',
//             value: 'Investment Management',
//             key: 'Investment Management',
//           },
//           {
//             title: 'Securities and Commodity Exchanges',
//             value: 'Securities and Commodity Exchanges',
//             key: 'Securities and Commodity Exchanges',
//           },
//           {
//             title: 'Venture Capital and Private Equity Principals',
//             value: 'Venture Capital and Private Equity Principals',
//             key: 'Venture Capital and Private Equity Principals',
//           },
//         ],
//       },
//       {
//         title: 'Credit Intermediation',
//         value: 'Credit Intermediation',
//         key: 'Credit Intermediation',
//         children: [
//           {
//             title: 'Banking',
//             value: 'Banking',
//             key: 'Banking',
//           },
//           {
//             title: 'International Trade and Development',
//             value: 'International Trade and Development',
//             key: 'International Trade and Development',
//           },
//           {
//             title: 'Loan Brokers',
//             value: 'Loan Brokers',
//             key: 'Loan Brokers',
//           },
//           {
//             title: 'Savings Institutions',
//             value: 'Savings Institutions',
//             key: 'Savings Institutions',
//           },
//           {
//             title: 'Funds and Trusts',
//             value: 'Funds and Trusts',
//             key: 'Funds and Trusts',
//           },
//         ],
//       },
//       {
//         title: 'Insurance and Employee Benefit Funds',
//         value: 'Insurance and Employee Benefit Funds',
//         key: 'Insurance and Employee Benefit Funds',
//         children: [
//           {
//             title: 'Pension Funds',
//             value: 'Pension Funds',
//             key: 'Pension Funds',
//           },
//           {
//             title: 'Trusts and Estates',
//             value: 'Trusts and Estates',
//             key: 'Trusts and Estates',
//           },
//         ],
//       },
//       {
//         title: 'Insurance',
//         value: 'Insurance',
//         key: 'Insurance',
//         children: [
//           {
//             title: 'Claims Adjusting, Actuarial Services',
//             value: 'Claims Adjusting, Actuarial Services',
//             key: 'Claims Adjusting, Actuarial Services',
//           },
//           {
//             title: 'Insurance Agencies and Brokerages',
//             value: 'Insurance Agencies and Brokerages',
//             key: 'Insurance Agencies and Brokerages',
//           },
//           {
//             title: 'Insurance Carriers',
//             value: 'Insurance Carriers',
//             key: 'Insurance Carriers',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Government Administration',
//     value: 'Government Administration',
//     key: 'Government Administration',
//     children: [
//       {
//         title: 'Administration of Justice',
//         value: 'Administration of Justice',
//         key: 'Administration of Justice',
//         children: [
//           {
//             title: 'Correctional Institutions',
//             value: 'Correctional Institutions',
//             key: 'Correctional Institutions',
//           },
//           {
//             title: 'Courts of Law',
//             value: 'Courts of Law',
//             key: 'Courts of Law',
//           },
//         ],
//       },
//       {
//         title: 'Fire Protection',
//         value: 'Fire Protection',
//         key: 'Fire Protection',
//       },
//       {
//         title: 'Law Enforcement',
//         value: 'Law Enforcement',
//         key: 'Law Enforcement',
//       },
//       {
//         title: 'Public Safety',
//         value: 'Public Safety',
//         key: 'Public Safety',
//       },
//       {
//         title: 'Economic Programs',
//         value: 'Economic Programs',
//         key: 'Economic Programs',
//       },
//       {
//         title: 'Transportation Programs',
//         value: 'Transportation Programs',
//         key: 'Transportation Programs',
//       },
//       {
//         title: 'Utilities Administration',
//         value: 'Utilities Administration',
//         key: 'Utilities Administration',
//       },
//       {
//         title: 'Environmental Quality Programs',
//         value: 'Environmental Quality Programs',
//         key: 'Environmental Quality Programs',
//         children: [
//           {
//             title: 'Air, Water, and Waste Program Management',
//             value: 'Air, Water, and Waste Program Management',
//             key: 'Air, Water, and Waste Program Management',
//           },
//           {
//             title: 'Conservation Programs',
//             value: 'Conservation Programs',
//             key: 'Conservation Programs',
//           },
//         ],
//       },
//       {
//         title: 'Health and Human Services',
//         value: 'Health and Human Services',
//         key: 'Health and Human Services 1',
//         children: [
//           {
//             title: 'Education Administration Programs',
//             value: 'Education Administration Programs',
//             key: 'Education Administration Programs',
//           },
//           {
//             title: 'Public Assistance Programs',
//             value: 'Public Assistance Programs',
//             key: 'Public Assistance Programs',
//           },
//           {
//             title: 'Public Health',
//             value: 'Public Health',
//             key: 'Public Health',
//           },
//         ],
//       },
//       {
//         title: 'Housing and Community Development',
//         value: 'Housing and Community Development',
//         key: 'Housing and Community Development',
//         children: [
//           {
//             title: 'Community Development and Urban Planning',
//             value: 'Community Development and Urban Planning',
//             key: 'Community Development and Urban Planning',
//           },
//           {
//             title: 'Housing Programs',
//             value: 'Housing Programs',
//             key: 'Housing Programs',
//           },
//         ],
//       },
//       {
//         title: 'Military and International Affairs',
//         value: 'Military and International Affairs',
//         key: 'Military and International Affairs',
//         children: [
//           {
//             title: 'Armed Forces',
//             value: 'Armed Forces',
//             key: 'Armed Forces',
//           },
//           {
//             title: 'International Affairs',
//             value: 'International Affairs',
//             key: 'International Affairs',
//           },
//         ],
//       },
//       {
//         title: 'Public Policy Offices',
//         value: 'Public Policy Offices',
//         key: 'Public Policy Offices',
//         children: [
//           {
//             title: 'Executive Offices',
//             value: 'Executive Offices',
//             key: 'Executive Offices',
//           },
//           {
//             title: 'Legislative Offices',
//             value: 'Legislative Offices',
//             key: 'Legislative Offices',
//           },
//         ],
//       },
//       {
//         title: 'Space Research and Technology',
//         value: 'Space Research and Technology',
//         key: 'Space Research and Technology',
//       },
//       {
//         title: 'Holding Companies',
//         value: 'Holding Companies',
//         key: 'Holding Companies',
//       },
//     ],
//   },
//   {
//     title: 'Health and Human Services',
//     value: 'Health and Human Services',
//     key: 'Health and Human Services',
//     children: [
//       {
//         title: 'Hospitals and Health Care',
//         value: 'Hospitals and Health Care',
//         key: 'Hospitals and Health Care',
//       },
//       {
//         title: 'Community Services',
//         value: 'Community Services',
//         key: 'Community Services',
//         children: [
//           {
//             title: 'Services for the Elderly and Disabled',
//             value: 'Services for the Elderly and Disabled',
//             key: 'Services for the Elderly and Disabled',
//           },
//           {
//             title: 'Hospitals',
//             value: 'Hospitals',
//             key: 'Hospitals',
//           },
//           {
//             title: 'Individual and Family Services',
//             value: 'Individual and Family Services',
//             key: 'Individual and Family Services',
//           },
//           {
//             title: 'Child Day Care Services',
//             value: 'Child Day Care Services',
//             key: 'Child Day Care Services',
//           },
//           {
//             title: 'Emergency and Relief Services',
//             value: 'Emergency and Relief Services',
//             key: 'Emergency and Relief Services',
//           },
//           {
//             title: 'Vocational Rehabilitation Services',
//             value: 'Vocational Rehabilitation Services',
//             key: 'Vocational Rehabilitation Services',
//           },
//         ],
//       },
//       {
//         title: 'Medical Practices',
//         value: 'Medical Practices',
//         key: 'Medical Practices',
//         children: [
//           {
//             title: 'Alternative Medicine',
//             value: 'Alternative Medicine',
//             key: 'Alternative Medicine',
//           },
//           {
//             title: 'Ambulance Services',
//             value: 'Ambulance Services',
//             key: 'Ambulance Services',
//           },
//           {
//             title: 'Chiropractors',
//             value: 'Chiropractors',
//             key: 'Chiropractors',
//           },
//           {
//             title: 'Dentists',
//             value: 'Dentists',
//             key: 'Dentists',
//           },
//           {
//             title: 'Family Planning Centers',
//             value: 'Family Planning Centers',
//             key: 'Family Planning Centers',
//           },
//           {
//             title: 'Home Health Care Services',
//             value: 'Home Health Care Services',
//             key: 'Home Health Care Services',
//           },
//           {
//             title: 'Medical and Diagnostic Laboratories',
//             value: 'Medical and Diagnostic Laboratories',
//             key: 'Medical and Diagnostic Laboratories',
//           },
//           {
//             title: 'Mental Health Care',
//             value: 'Mental Health Care',
//             key: 'Mental Health Care',
//           },
//           {
//             title: 'Optometrists',
//             value: 'Optometrists',
//             key: 'Optometrists',
//           },
//           {
//             title: 'Outpatient Care Centers',
//             value: 'Outpatient Care Centers',
//             key: 'Outpatient Care Centers',
//           },
//           {
//             title: 'Physical, Occupational and Speech Therapists',
//             value: 'Physical, Occupational and Speech Therapists',
//             key: 'Physical, Occupational and Speech Therapists',
//           },
//           {
//             title: 'Physicians',
//             value: 'Physicians',
//             key: 'Physicians',
//           },
//           {
//             title: 'Nursing Homes and Residential Care Facilities',
//             value: 'Nursing Homes and Residential Care Facilities',
//             key: 'Nursing Homes and Residential Care Facilities',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Manufacturing',
//     value: 'Manufacturing',
//     key: 'Manufacturing',
//     children: [
//       {
//         title: 'Apparel Manufacturing',
//         value: 'Apparel Manufacturing',
//         key: 'Apparel Manufacturing',
//       },
//       {
//         title: 'Fashion Accessories Manufacturing',
//         value: 'Fashion Accessories Manufacturing',
//         key: 'Fashion Accessories Manufacturing',
//       },
//       {
//         title: 'Appliances, Electrical, and Electronics Manufacturing',
//         value: 'Appliances, Electrical, and Electronics Manufacturing',
//         key: 'Appliances, Electrical, and Electronics Manufacturing',
//         children: [
//           {
//             title: 'Electric Lighting Equipment Manufacturing',
//             value: 'Electric Lighting Equipment Manufacturing',
//             key: 'Electric Lighting Equipment Manufacturing',
//           },
//           {
//             title: 'Electrical Equipment Manufacturing',
//             value: 'Electrical Equipment Manufacturing',
//             key: 'Electrical Equipment Manufacturing',
//           },
//           {
//             title: 'Fuel Cell Manufacturing',
//             value: 'Fuel Cell Manufacturing',
//             key: 'Fuel Cell Manufacturing',
//           },
//           {
//             title: 'Household Appliance Manufacturing',
//             value: 'Household Appliance Manufacturing',
//             key: 'Household Appliance Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Chemical Manufacturing',
//         value: 'Chemical Manufacturing',
//         key: 'Chemical Manufacturing',
//         children: [
//           {
//             title: 'Agricultural Chemical Manufacturing',
//             value: 'Agricultural Chemical Manufacturing',
//             key: 'Agricultural Chemical Manufacturing',
//           },
//           {
//             title: 'Artificial Rubber and Synthetic Fiber Manufacturing',
//             value: 'Artificial Rubber and Synthetic Fiber Manufacturing',
//             key: 'Artificial Rubber and Synthetic Fiber Manufacturing',
//           },
//           {
//             title: 'Chemical Raw Materials Manufacturing',
//             value: 'Chemical Raw Materials Manufacturing',
//             key: 'Chemical Raw Materials Manufacturing',
//           },
//           {
//             title: 'Paint, Coating, and Adhesive Manufacturing',
//             value: 'Paint, Coating, and Adhesive Manufacturing',
//             key: 'Paint, Coating, and Adhesive Manufacturing',
//           },
//           {
//             title: 'Personal Care Product Manufacturing',
//             value: 'Personal Care Product Manufacturing',
//             key: 'Personal Care Product Manufacturing',
//           },
//           {
//             title: 'Pharmaceutical Manufacturing',
//             value: 'Pharmaceutical Manufacturing',
//             key: 'Pharmaceutical Manufacturing',
//           },
//           {
//             title: 'Soap and Cleaning Product Manufacturing',
//             value: 'Soap and Cleaning Product Manufacturing',
//             key: 'Soap and Cleaning Product Manufacturing',
//           },
//           {
//             title: 'Climate Technology Product Manufacturing',
//             value: 'Climate Technology Product Manufacturing',
//             key: 'Climate Technology Product Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Computers and Electronics Manufacturing',
//         value: 'Computers and Electronics Manufacturing',
//         key: 'Computers and Electronics Manufacturing',
//         children: [
//           {
//             title: 'Audio and Video Equipment Manufacturing',
//             value: 'Audio and Video Equipment Manufacturing',
//             key: 'Audio and Video Equipment Manufacturing',
//           },
//           {
//             title: 'Communications Equipment Manufacturing',
//             value: 'Communications Equipment Manufacturing',
//             key: 'Communications Equipment Manufacturing',
//           },
//           {
//             title: 'Computer Hardware Manufacturing',
//             value: 'Computer Hardware Manufacturing',
//             key: 'Computer Hardware Manufacturing',
//           },
//           {
//             title: 'Accessible Hardware Manufacturing',
//             value: 'Accessible Hardware Manufacturing',
//             key: 'Accessible Hardware Manufacturing',
//           },
//           {
//             title: 'Magnetic and Optical Media Manufacturing',
//             value: 'Magnetic and Optical Media Manufacturing',
//             key: 'Magnetic and Optical Media Manufacturing',
//           },
//           {
//             title: 'Measuring and Control Instrument Manufacturing',
//             value: 'Measuring and Control Instrument Manufacturing',
//             key: 'Measuring and Control Instrument Manufacturing',
//           },
//           {
//             title: 'Smart Meter Manufacturing',
//             value: 'Smart Meter Manufacturing',
//             key: 'Smart Meter Manufacturing',
//           },
//           {
//             title: 'Semiconductor Manufacturing',
//             value: 'Semiconductor Manufacturing',
//             key: 'Semiconductor Manufacturing',
//           },
//           {
//             title: 'Renewable Energy Semiconductor Manufacturing',
//             value: 'Renewable Energy Semiconductor Manufacturing',
//             key: 'Renewable Energy Semiconductor Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Fabricated Metal Products',
//         value: 'Fabricated Metal Products',
//         key: 'Fabricated Metal Products',
//         children: [
//           {
//             title: 'Architectural and Structural Metal Manufacturing',
//             value: 'Architectural and Structural Metal Manufacturing',
//             key: 'Architectural and Structural Metal Manufacturing',
//           },
//           {
//             title: 'Boilers, Tanks, and Shipping Container Manufacturing',
//             value: 'Boilers, Tanks, and Shipping Container Manufacturing',
//             key: 'Boilers, Tanks, and Shipping Container Manufacturing',
//           },
//           {
//             title: 'Construction Hardware Manufacturing',
//             value: 'Construction Hardware Manufacturing',
//             key: 'Construction Hardware Manufacturing',
//           },
//           {
//             title: 'Cutlery and Handtool Manufacturing',
//             value: 'Cutlery and Handtool Manufacturing',
//             key: 'Cutlery and Handtool Manufacturing',
//           },
//           {
//             title: 'Metal Treatments',
//             value: 'Metal Treatments',
//             key: 'Metal Treatments',
//           },
//           {
//             title: 'Metal Valve, Ball, and Roller Manufacturing',
//             value: 'Metal Valve, Ball, and Roller Manufacturing',
//             key: 'Metal Valve, Ball, and Roller Manufacturing',
//           },
//           {
//             title: 'Spring and Wire Product Manufacturing',
//             value: 'Spring and Wire Product Manufacturing',
//             key: 'Spring and Wire Product Manufacturing',
//           },
//           {
//             title: 'Turned Products and Fastener Manufacturing',
//             value: 'Turned Products and Fastener Manufacturing',
//             key: 'Turned Products and Fastener Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Food and Beverage Manufacturing',
//         value: 'Food and Beverage Manufacturing',
//         key: 'Food and Beverage Manufacturing',
//         children: [
//           {
//             title: 'Breweries',
//             value: 'Breweries',
//             key: 'Breweries',
//           },
//           {
//             title: 'Distilleries',
//             value: 'Distilleries',
//             key: 'Distilleries',
//           },
//           {
//             title: 'Wineries',
//             value: 'Wineries',
//             key: 'Wineries',
//           },
//           {
//             title: 'Animal Feed Manufacturing',
//             value: 'Animal Feed Manufacturing',
//             key: 'Animal Feed Manufacturing',
//           },
//           {
//             title: 'Baked Goods Manufacturing',
//             value: 'Baked Goods Manufacturing',
//             key: 'Baked Goods Manufacturing',
//           },
//           {
//             title: 'Beverage Manufacturing',
//             value: 'Beverage Manufacturing',
//             key: 'Beverage Manufacturing',
//           },
//           {
//             title: 'Dairy Product Manufacturing',
//             value: 'Dairy Product Manufacturing',
//             key: 'Dairy Product Manufacturing',
//           },
//           {
//             title: 'Fruit and Vegetable Preserves Manufacturing',
//             value: 'Fruit and Vegetable Preserves Manufacturing',
//             key: 'Fruit and Vegetable Preserves Manufacturing',
//           },
//           {
//             title: 'Meat Products Manufacturing',
//             value: 'Meat Products Manufacturing',
//             key: 'Meat Products Manufacturing',
//           },
//           {
//             title: 'Seafood Product Manufacturing',
//             value: 'Seafood Product Manufacturing',
//             key: 'Seafood Product Manufacturing',
//           },
//           {
//             title: 'Sugar and Confectionery Product Manufacturing',
//             value: 'Sugar and Confectionery Product Manufacturing',
//             key: 'Sugar and Confectionery Product Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Furniture and Home Furnishings Manufacturing',
//         value: 'Furniture and Home Furnishings Manufacturing',
//         key: 'Furniture and Home Furnishings Manufacturing',
//         children: [
//           {
//             title: 'Household and Institutional Furniture Manufacturing',
//             value: 'Household and Institutional Furniture Manufacturing',
//             key: 'Household and Institutional Furniture Manufacturing',
//           },
//           {
//             title: 'Mattress and Blinds Manufacturing',
//             value: 'Mattress and Blinds Manufacturing',
//             key: 'Mattress and Blinds Manufacturing',
//           },
//           {
//             title: 'Office Furniture and Fixtures Manufacturing',
//             value: 'Office Furniture and Fixtures Manufacturing',
//             key: 'Office Furniture and Fixtures Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Glass, Ceramics and Concrete Manufacturing',
//         value: 'Glass, Ceramics and Concrete Manufacturing',
//         key: 'Glass, Ceramics and Concrete Manufacturing',
//         children: [
//           {
//             title: 'Abrasives and Nonmetallic Minerals Manufacturing',
//             value: 'Abrasives and Nonmetallic Minerals Manufacturing',
//             key: 'Abrasives and Nonmetallic Minerals Manufacturing',
//           },
//           {
//             title: 'Clay and Refractory Products Manufacturing',
//             value: 'Clay and Refractory Products Manufacturing',
//             key: 'Clay and Refractory Products Manufacturing',
//           },
//           {
//             title: 'Glass Product Manufacturing',
//             value: 'Glass Product Manufacturing',
//             key: 'Glass Product Manufacturing',
//           },
//           {
//             title: 'Lime and Gypsum Products Manufacturing',
//             value: 'Lime and Gypsum Products Manufacturing',
//             key: 'Lime and Gypsum Products Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Leather Product Manufacturing',
//         value: 'Leather Product Manufacturing',
//         key: 'Leather Product Manufacturing',
//       },
//       {
//         title: 'Footwear Manufacturing',
//         value: 'Footwear Manufacturing',
//         key: 'Footwear Manufacturing',
//         children: [
//           {
//             title: "Women's Handbag Manufacturing",
//             value: "Women's Handbag Manufacturing",
//             key: "Women's Handbag Manufacturing",
//           },
//         ],
//       },
//       {
//         title: 'Machinery Manufacturing',
//         value: 'Machinery Manufacturing',
//         key: 'Machinery Manufacturing',
//         children: [
//           {
//             title: 'Agriculture, Construction, Mining Machinery Manufacturing',
//             value: 'Agriculture, Construction, Mining Machinery Manufacturing',
//             key: 'Agriculture, Construction, Mining Machinery Manufacturing',
//           },
//           {
//             title: 'Automation Machinery Manufacturing',
//             value: 'Automation Machinery Manufacturing',
//             key: 'Automation Machinery Manufacturing',
//           },
//           {
//             title: 'Robot Manufacturing',
//             value: 'Robot Manufacturing',
//             key: 'Robot Manufacturing',
//           },
//           {
//             title: 'Commercial and Service Industry Machinery Manufacturing',
//             value: 'Commercial and Service Industry Machinery Manufacturing',
//             key: 'Commercial and Service Industry Machinery Manufacturing',
//           },
//           {
//             title: 'Engines and Power Transmission Equipment Manufacturing',
//             value: 'Engines and Power Transmission Equipment Manufacturing',
//             key: 'Engines and Power Transmission Equipment Manufacturing',
//           },
//           {
//             title: 'Renewable Energy Equipment Manufacturing',
//             value: 'Renewable Energy Equipment Manufacturing',
//             key: 'Renewable Energy Equipment Manufacturing',
//           },
//           {
//             title: 'HVAC and Refrigeration Equipment Manufacturing',
//             value: 'HVAC and Refrigeration Equipment Manufacturing',
//             key: 'HVAC and Refrigeration Equipment Manufacturing',
//           },
//           {
//             title: 'Industrial Machinery Manufacturing',
//             value: 'Industrial Machinery Manufacturing',
//             key: 'Industrial Machinery Manufacturing',
//           },
//           {
//             title: 'Metalworking Machinery Manufacturing',
//             value: 'Metalworking Machinery Manufacturing',
//             key: 'Metalworking Machinery Manufacturing',
//           },
//           {
//             title: 'Medical Equipment Manufacturing',
//             value: 'Medical Equipment Manufacturing',
//             key: 'Medical Equipment Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Oil and Coal Product Manufacturing',
//         value: 'Oil and Coal Product Manufacturing',
//         key: 'Oil and Coal Product Manufacturing',
//       },
//       {
//         title: 'Paper and Forest Product Manufacturing',
//         value: 'Paper and Forest Product Manufacturing',
//         key: 'Paper and Forest Product Manufacturing',
//       },
//       {
//         title: 'Plastics and Rubber Product Manufacturing',
//         value: 'Plastics and Rubber Product Manufacturing',
//         key: 'Plastics and Rubber Product Manufacturing',
//         children: [
//           {
//             title: 'Plastics Manufacturing',
//             value: 'Plastics Manufacturing',
//             key: 'Plastics Manufacturing',
//           },
//           {
//             title: 'Rubber Products Manufacturing',
//             value: 'Rubber Products Manufacturing',
//             key: 'Rubber Products Manufacturing',
//           },
//         ],
//       },
//       {
//         title: 'Primary Metal Manufacturing',
//         value: 'Primary Metal Manufacturing',
//         key: 'Primary Metal Manufacturing',
//       },
//       {
//         title: 'Printing Services',
//         value: 'Printing Services',
//         key: 'Printing Services',
//       },
//       {
//         title: 'Sporting Goods Manufacturing',
//         value: 'Sporting Goods Manufacturing',
//         key: 'Sporting Goods Manufacturing',
//       },
//       {
//         title: 'Textile Manufacturing',
//         value: 'Textile Manufacturing',
//         key: 'Textile Manufacturing',
//       },
//       {
//         title: 'Tobacco Manufacturing',
//         value: 'Tobacco Manufacturing',
//         key: 'Tobacco Manufacturing',
//       },
//       {
//         title: 'Transportation Equipment Manufacturing',
//         value: 'Transportation Equipment Manufacturing',
//         key: 'Transportation Equipment Manufacturing',
//         children: [
//           {
//             title: 'Aviation and Aerospace Component Manufacturing',
//             value: 'Aviation and Aerospace Component Manufacturing',
//             key: 'Aviation and Aerospace Component Manufacturing',
//           },
//           {
//             title: 'Defense and Space Manufacturing',
//             value: 'Defense and Space Manufacturing',
//             key: 'Defense and Space Manufacturing',
//           },
//           {
//             title: 'Motor Vehicle Manufacturing',
//             value: 'Motor Vehicle Manufacturing',
//             key: 'Motor Vehicle Manufacturing',
//           },
//           {
//             title: 'Alternative Fuel Vehicle Manufacturing',
//             value: 'Alternative Fuel Vehicle Manufacturing',
//             key: 'Alternative Fuel Vehicle Manufacturing',
//           },
//           {
//             title: 'Motor Vehicle Parts Manufacturing',
//             value: 'Motor Vehicle Parts Manufacturing',
//             key: 'Motor Vehicle Parts Manufacturing',
//           },
//           {
//             title: 'Railroad Equipment Manufacturing',
//             value: 'Railroad Equipment Manufacturing',
//             key: 'Railroad Equipment Manufacturing',
//           },
//           {
//             title: 'Shipbuilding',
//             value: 'Shipbuilding',
//             key: 'Shipbuilding',
//           },
//           {
//             title: 'Wood Product Manufacturing',
//             value: 'Wood Product Manufacturing',
//             key: 'Wood Product Manufacturing',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Oil, Gas, and Mining',
//     value: 'Oil, Gas, and Mining',
//     key: 'Oil, Gas, and Mining 1',
//     children: [
//       {
//         title: 'Oil, Gas, and Mining',
//         value: 'Oil, Gas, and Mining',
//         key: 'Oil, Gas, and Mining',
//         children: [
//           { title: 'Coal Mining', value: 'Coal Mining', key: 'Coal Mining' },
//           {
//             title: 'Metal Ore Mining',
//             value: 'Metal Ore Mining',
//             key: 'Metal Ore Mining',
//           },
//           {
//             title: 'Nonmetallic Mineral Mining',
//             value: 'Nonmetallic Mineral Mining',
//             key: 'Nonmetallic Mineral Mining',
//           },
//         ],
//       },
//       {
//         title: 'Oil and Gas',
//         value: 'Oil and Gas',
//         key: 'Oil and Gas',
//         children: [
//           {
//             title: 'Natural Gas Extraction',
//             value: 'Natural Gas Extraction',
//             key: 'Natural Gas Extraction',
//           },
//           {
//             title: 'Oil Extraction',
//             value: 'Oil Extraction',
//             key: 'Oil Extraction',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Professional Services',
//     value: 'Professional Services',
//     key: 'Professional Services 1',
//     children: [
//       {
//         title: 'Professional Services',
//         value: 'Professional Services',
//         key: 'Professional Services',
//       },
//       {
//         title: 'Accounting',
//         value: 'Accounting',
//         key: 'Accounting',
//       },
//       {
//         title: 'Advertising Services',
//         value: 'Advertising Services',
//         key: 'Advertising Services',
//       },
//       {
//         title: 'Government Relations Services',
//         value: 'Government Relations Services',
//         key: 'Government Relations Services',
//       },
//       {
//         title: 'Public Relations and Communications Services',
//         value: 'Public Relations and Communications Services',
//         key: 'Public Relations and Communications Services',
//       },
//       {
//         title: 'Market Research',
//         value: 'Market Research',
//         key: 'Market Research',
//       },
//       {
//         title: 'Architecture and Planning',
//         value: 'Architecture and Planning',
//         key: 'Architecture and Planning',
//         children: [
//           {
//             title: 'Accessible Architecture and Design',
//             value: 'Accessible Architecture and Design',
//             key: 'Accessible Architecture and Design',
//           },
//         ],
//       },
//       {
//         title: 'Business Consulting and Services',
//         value: 'Business Consulting and Services',
//         key: 'Business Consulting and Services',
//         children: [
//           {
//             title: 'Environmental Services',
//             value: 'Environmental Services',
//             key: 'Environmental Services',
//           },
//           {
//             title: 'Human Resources Services',
//             value: 'Human Resources Services',
//             key: 'Human Resources Services',
//           },
//           {
//             title: 'Marketing Services',
//             value: 'Marketing Services',
//             key: 'Marketing Services',
//           },
//           {
//             title: 'Operations Consulting',
//             value: 'Operations Consulting',
//             key: 'Operations Consulting',
//           },
//           {
//             title: 'Outsourcing and Offshoring Consulting',
//             value: 'Outsourcing and Offshoring Consulting',
//             key: 'Outsourcing and Offshoring Consulting',
//           },
//           {
//             title: 'Strategic Management Services',
//             value: 'Strategic Management Services',
//             key: 'Strategic Management Services',
//           },
//         ],
//       },
//       {
//         title: 'Design Services',
//         value: 'Design Services',
//         key: 'Design Services',
//         children: [
//           {
//             title: 'Graphic Design',
//             value: 'Graphic Design',
//             key: 'Graphic Design',
//           },
//           {
//             title: 'Regenerative Design',
//             value: 'Regenerative Design',
//             key: 'Regenerative Design',
//           },
//           {
//             title: 'Interior Design',
//             value: 'Interior Design',
//             key: 'Interior Design',
//           },
//         ],
//       },
//       {
//         title: 'Engineering Services',
//         value: 'Engineering Services',
//         key: 'Engineering Services',
//         children: [
//           {
//             title: 'Robotics Engineering',
//             value: 'Robotics Engineering',
//             key: 'Robotics Engineering',
//           },
//         ],
//       },
//       {
//         title: 'Surveying and Mapping Services',
//         value: 'Surveying and Mapping Services',
//         key: 'Surveying and Mapping Services',
//       },
//       {
//         title: 'IT Services and IT Consulting',
//         value: 'IT Services and IT Consulting',
//         key: 'IT Services and IT Consulting',
//         children: [
//           {
//             title: 'Computer and Network Security',
//             value: 'Computer and Network Security',
//             key: 'Computer and Network Security',
//           },
//           {
//             title: 'Digital Accessibility Services',
//             value: 'Digital Accessibility Services',
//             key: 'Digital Accessibility Services',
//           },
//           {
//             title: 'IT System Custom Software Development',
//             value: 'IT System Custom Software Development',
//             key: 'IT System Custom Software Development',
//           },
//           {
//             title: 'IT System Data Services',
//             value: 'IT System Data Services',
//             key: 'IT System Data Services',
//           },
//           {
//             title: 'IT System Design Services',
//             value: 'IT System Design Services',
//             key: 'IT System Design Services',
//           },
//           {
//             title: 'IT System Installation and Disposal',
//             value: 'IT System Installation and Disposal',
//             key: 'IT System Installation and Disposal',
//           },
//           {
//             title: 'IT System Operations and Maintenance',
//             value: 'IT System Operations and Maintenance',
//             key: 'IT System Operations and Maintenance',
//           },
//           {
//             title: 'IT System Testing and Evaluation',
//             value: 'IT System Testing and Evaluation',
//             key: 'IT System Testing and Evaluation',
//           },
//           {
//             title: 'IT System Training and Support',
//             value: 'IT System Training and Support',
//             key: 'IT System Training and Support',
//           },
//         ],
//       },
//       {
//         title: 'Legal Services',
//         value: 'Legal Services',
//         key: 'Legal Services',
//         children: [
//           {
//             title: 'Alternative Dispute Resolution',
//             value: 'Alternative Dispute Resolution',
//             key: 'Alternative Dispute Resolution',
//           },
//           {
//             title: 'Law Practice',
//             value: 'Law Practice',
//             key: 'Law Practice',
//           },
//         ],
//       },
//       {
//         title: 'Photography',
//         value: 'Photography',
//         key: 'Photography',
//       },
//       {
//         title: 'Research Services',
//         value: 'Research Services',
//         key: 'Research Services',
//         children: [
//           {
//             title: 'Biotechnology Research',
//             value: 'Biotechnology Research',
//             key: 'Biotechnology Research',
//           },
//           {
//             title: 'Nanotechnology Research',
//             value: 'Nanotechnology Research',
//             key: 'Nanotechnology Research',
//           },
//           {
//             title: 'Think Tanks',
//             value: 'Think Tanks',
//             key: 'Think Tanks',
//           },
//         ],
//       },
//       {
//         title: 'Services for Renewable Energy',
//         value: 'Services for Renewable Energy',
//         key: 'Services for Renewable Energy',
//       },
//       {
//         title: 'Veterinary Services',
//         value: 'Veterinary Services',
//         key: 'Veterinary Services',
//       },
//     ],
//   },
//   {
//     title: 'Real Estate and Equipment Rental Services',
//     value: 'Real Estate and Equipment Rental Services',
//     key: 'Real Estate and Equipment Rental Services 1',
//     children: [
//       {
//         title: 'Real Estate and Equipment Rental Services',
//         value: 'Real Estate and Equipment Rental Services',
//         key: 'Real Estate and Equipment Rental Services',
//       },
//       {
//         title: 'Equipment Rental Services',
//         value: 'Equipment Rental Services',
//         key: 'Equipment Rental Services',
//         children: [
//           {
//             title: 'Commercial and Industrial Equipment Rental',
//             value: 'Commercial and Industrial Equipment Rental',
//             key: 'Commercial and Industrial Equipment Rental',
//           },
//           {
//             title: 'Consumer Goods Rental',
//             value: 'Consumer Goods Rental',
//             key: 'Consumer Goods Rental',
//           },
//         ],
//       },
//       {
//         title: 'Real Estate',
//         value: 'Real Estate',
//         key: 'Real Estate',
//         children: [
//           {
//             title: 'Leasing Non-residential Real Estate',
//             value: 'Leasing Non-residential Real Estate',
//             key: 'Leasing Non-residential Real Estate',
//           },
//           {
//             title: 'Leasing Residential Real Estate',
//             value: 'Leasing Residential Real Estate',
//             key: 'Leasing Residential Real Estate',
//           },
//           {
//             title: 'Real Estate Agents and Brokers',
//             value: 'Real Estate Agents and Brokers',
//             key: 'Real Estate Agents and Brokers',
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Retail',
//     value: 'Retail',
//     key: 'Retail',
//     children: [
//       {
//         title: 'Food and Beverage Retail',
//         value: 'Food and Beverage Retail',
//         key: 'Food and Beverage Retail',
//         children: [
//           {
//             title: 'Retail Groceries',
//             value: 'Retail Groceries',
//             key: 'Retail Groceries',
//           },
//           {
//             title: 'Online and Mail Order Retail',
//             value: 'Online and Mail Order Retail',
//             key: 'Online and Mail Order Retail',
//           },
//         ],
//       },
//       {
//         title: 'Retail Apparel and Fashion',
//         value: 'Retail Apparel and Fashion',
//         key: 'Retail Apparel and Fashion',
//       },
//       {
//         title: 'Retail Appliances, Electrical, and Electronic Equipment',
//         value: 'Retail Appliances, Electrical, and Electronic Equipment',
//         key: 'Retail Appliances, Electrical, and Electronic Equipment',
//       },
//       {
//         title: 'Retail Art Dealers',
//         value: 'Retail Art Dealers',
//         key: 'Retail Art Dealers',
//       },
//       {
//         title: 'Retail Art Supplies',
//         value: 'Retail Art Supplies',
//         key: 'Retail Art Supplies',
//       },
//       {
//         title: 'Retail Books and Printed News',
//         value: 'Retail Books and Printed News',
//         key: 'Retail Books and Printed News',
//       },
//       {
//         title: 'Retail Building Materials and Garden Equipment',
//         value: 'Retail Building Materials and Garden Equipment',
//         key: 'Retail Building Materials and Garden Equipment',
//       },
//       {
//         title: 'Retail Florists',
//         value: 'Retail Florists',
//         key: 'Retail Florists',
//       },
//       {
//         title: 'Retail Furniture and Home Furnishings',
//         value: 'Retail Furniture and Home Furnishings',
//         key: 'Retail Furniture and Home Furnishings',
//       },
//       {
//         title: 'Retail Gasoline',
//         value: 'Retail Gasoline',
//         key: 'Retail Gasoline',
//       },
//       {
//         title: 'Retail Health and Personal Care Products',
//         value: 'Retail Health and Personal Care Products',
//         key: 'Retail Health and Personal Care Products',
//         children: [
//           {
//             title: 'Retail Pharmacies',
//             value: 'Retail Pharmacies',
//             key: 'Retail Pharmacies',
//           },
//         ],
//       },
//       {
//         title: 'Retail Luxury Goods and Jewelry',
//         value: 'Retail Luxury Goods and Jewelry',
//         key: 'Retail Luxury Goods and Jewelry',
//       },
//       {
//         title: 'Retail Motor Vehicles',
//         value: 'Retail Motor Vehicles',
//         key: 'Retail Motor Vehicles',
//       },
//       {
//         title: 'Retail Musical Instruments',
//         value: 'Retail Musical Instruments',
//         key: 'Retail Musical Instruments',
//       },
//       {
//         title: 'Retail Office Equipment',
//         value: 'Retail Office Equipment',
//         key: 'Retail Office Equipment',
//       },
//       {
//         title: 'Retail Office Supplies and Gifts',
//         value: 'Retail Office Supplies and Gifts',
//         key: 'Retail Office Supplies and Gifts',
//       },
//       {
//         title: 'Retail Recyclable Materials & Used Merchandise',
//         value: 'Retail Recyclable Materials & Used Merchandise',
//         key: 'Retail Recyclable Materials & Used Merchandise',
//       },
//     ],
//   },
//   {
//     title: 'Technology, Information, and Media',
//     value: 'Technology, Information, and Media',
//     key: 'Technology, Information, and Media 1',
//     children: [
//       {
//         title: 'Technology, Information and Media',
//         value: 'Technology, Information and Media',
//         key: 'Technology, Information and Media',
//       },
//       {
//         title: 'Media & Telecommunications',
//         value: 'Media & Telecommunications',
//         key: 'Media & Telecommunications',
//         children: [
//           {
//             title: 'Book and Periodical Publishing',
//             value: 'Book and Periodical Publishing',
//             key: 'Book and Periodical Publishing',
//             children: [
//               {
//                 title: 'Book Publishing',
//                 value: 'Book Publishing',
//                 key: 'Book Publishing',
//               },
//               {
//                 title: 'Newspaper Publishing',
//                 value: 'Newspaper Publishing',
//                 key: 'Newspaper Publishing',
//               },
//               {
//                 title: 'Periodical Publishing',
//                 value: 'Periodical Publishing',
//                 key: 'Periodical Publishing',
//               },
//             ],
//           },
//           {
//             title: 'Broadcast Media Production and Distribution',
//             value: 'Broadcast Media Production and Distribution',
//             key: 'Broadcast Media Production and Distribution',
//             children: [
//               {
//                 title: 'Cable and Satellite Programming',
//                 value: 'Cable and Satellite Programming',
//                 key: 'Cable and Satellite Programming',
//               },
//               {
//                 title: 'Radio and Television Broadcasting',
//                 value: 'Radio and Television Broadcasting',
//                 key: 'Radio and Television Broadcasting',
//               },
//             ],
//           },
//           {
//             title: 'Movies, Videos and Sound',
//             value: 'Movies, Videos and Sound',
//             key: 'Movies, Videos and Sound',
//             children: [
//               {
//                 title: 'Animation and Post-production',
//                 value: 'Animation and Post-production',
//                 key: 'Animation and Post-production',
//               },
//               {
//                 title: 'Media Production',
//                 value: 'Media Production',
//                 key: 'Media Production',
//               },
//               {
//                 title: 'Movies and Sound Recording',
//                 value: 'Movies and Sound Recording',
//                 key: 'Movies and Sound Recording',
//                 children: [
//                   {
//                     title: 'Sound Recording',
//                     value: 'Sound Recording',
//                     key: 'Sound Recording',
//                   },
//                   {
//                     title: 'Sheet Music Publishing',
//                     value: 'Sheet Music Publishing',
//                     key: 'Sheet Music Publishing',
//                   },
//                 ],
//               },
//             ],
//           },
//           {
//             title: 'Telecommunications',
//             value: 'Telecommunications',
//             key: 'Telecommunications',
//             children: [
//               {
//                 title: 'Satellite Telecommunications',
//                 value: 'Satellite Telecommunications',
//                 key: 'Satellite Telecommunications',
//               },
//               {
//                 title: 'Telecommunications Carriers',
//                 value: 'Telecommunications Carriers',
//                 key: 'Telecommunications Carriers',
//               },
//               {
//                 title: 'Wireless Services',
//                 value: 'Wireless Services',
//                 key: 'Wireless Services',
//               },
//             ],
//           },
//         ],
//       },
//       {
//         title: 'Technology, Information and Internet',
//         value: 'Technology, Information and Internet',
//         key: 'Technology, Information and Internet',
//         children: [
//           {
//             title: 'Data Infrastructure and Analytics',
//             value: 'Data Infrastructure and Analytics',
//             key: 'Data Infrastructure and Analytics',
//             children: [
//               {
//                 title: 'Blockchain Services',
//                 value: 'Blockchain Services',
//                 key: 'Blockchain Services',
//               },
//               {
//                 title: 'Business Intelligence Platforms',
//                 value: 'Business Intelligence Platforms',
//                 key: 'Business Intelligence Platforms',
//               },
//               {
//                 title: 'Climate Data and Analytics',
//                 value: 'Climate Data and Analytics',
//                 key: 'Climate Data and Analytics',
//               },
//             ],
//           },
//           {
//             title: 'Information Services',
//             value: 'Information Services',
//             key: 'Information Services',
//           },
//           {
//             title: 'Internet Publishing',
//             value: 'Internet Publishing',
//             key: 'Internet Publishing',
//             children: [
//               {
//                 title: 'Business Content',
//                 value: 'Business Content',
//                 key: 'Business Content',
//               },
//               {
//                 title: 'Online Audio and Video Media',
//                 value: 'Online Audio and Video Media',
//                 key: 'Online Audio and Video Media',
//               },
//               {
//                 title: 'Internet News',
//                 value: 'Internet News',
//                 key: 'Internet News',
//               },
//               {
//                 title: 'Libraries',
//                 value: 'Libraries',
//                 key: 'Libraries',
//               },
//               {
//                 title: 'Blogs',
//                 value: 'Blogs',
//                 key: 'Blogs',
//               },
//             ],
//           },
//           {
//             title: 'Internet Marketplace Platforms',
//             value: 'Internet Marketplace Platforms',
//             key: 'Internet Marketplace Platforms',
//             children: [
//               {
//                 title: 'Social Networking Platforms',
//                 value: 'Social Networking Platforms',
//                 key: 'Social Networking Platforms',
//               },
//             ],
//           },
//           {
//             title: 'Software Development',
//             value: 'Software Development',
//             key: 'Software Development',
//             children: [
//               {
//                 title: 'Computer Games',
//                 value: 'Computer Games',
//                 key: 'Computer Games',
//                 children: [
//                   {
//                     title: 'Mobile Gaming Apps',
//                     value: 'Mobile Gaming Apps',
//                     key: 'Mobile Gaming Apps',
//                   },
//                 ],
//               },
//               {
//                 title: 'Computer Networking Products',
//                 value: 'Computer Networking Products',
//                 key: 'Computer Networking Products',
//               },
//               {
//                 title: 'Data Security Software Products',
//                 value: 'Data Security Software Products',
//                 key: 'Data Security Software Products',
//               },
//               {
//                 title: 'Desktop Computing Software Products',
//                 value: 'Desktop Computing Software Products',
//                 key: 'Desktop Computing Software Products',
//               },
//               {
//                 title: 'Embedded Software Products',
//                 value: 'Embedded Software Products',
//                 key: 'Embedded Software Products',
//               },
//               {
//                 title: 'Mobile Computing Software Products',
//                 value: 'Mobile Computing Software Products',
//                 key: 'Mobile Computing Software Products',
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   {
//     title: 'Transportation, Logistics, Supply Chain, and Storage',
//     value: 'Transportation, Logistics, Supply Chain, and Storage',
//     key: 'Transportation, Logistics, Supply Chain, and Storage 1',
//     children: [
//       {
//         title: 'Transportation, Logistics, Supply Chain and Storage',
//         value: 'Transportation, Logistics, Supply Chain and Storage',
//         key: 'Transportation, Logistics, Supply Chain and Storage',
//       },
//       {
//         title: 'Airlines and Aviation',
//         value: 'Airlines and Aviation',
//         key: 'Airlines and Aviation',
//       },
//       {
//         title: 'Freight and Package Transportation',
//         value: 'Freight and Package Transportation',
//         key: 'Freight and Package Transportation',
//       },
//       {
//         title: 'Ground Passenger Transportation',
//         value: 'Ground Passenger Transportation',
//         key: 'Ground Passenger Transportation',
//         children: [
//           {
//             title: 'Interurban and Rural Bus Services',
//             value: 'Interurban and Rural Bus Services',
//             key: 'Interurban and Rural Bus Services',
//           },
//           {
//             title: 'School and Employee Bus Services',
//             value: 'School and Employee Bus Services',
//             key: 'School and Employee Bus Services',
//           },
//           {
//             title: 'Shuttles and Special Needs Transportation Services',
//             value: 'Shuttles and Special Needs Transportation Services',
//             key: 'Shuttles and Special Needs Transportation Services',
//           },
//           {
//             title: 'Sightseeing Transportation',
//             value: 'Sightseeing Transportation',
//             key: 'Sightseeing Transportation',
//           },
//           {
//             title: 'Taxi and Limousine Services',
//             value: 'Taxi and Limousine Services',
//             key: 'Taxi and Limousine Services',
//           },
//           {
//             title: 'Urban Transit Services',
//             value: 'Urban Transit Services',
//             key: 'Urban Transit Services',
//           },
//         ],
//       },
//       {
//         title: 'Maritime Transportation',
//         value: 'Maritime Transportation',
//         key: 'Maritime Transportation',
//       },
//       {
//         title: 'Pipeline Transportation',
//         value: 'Pipeline Transportation',
//         key: 'Pipeline Transportation',
//       },
//       {
//         title: 'Postal Services',
//         value: 'Postal Services',
//         key: 'Postal Services',
//       },
//       {
//         title: 'Rail Transportation',
//         value: 'Rail Transportation',
//         key: 'Rail Transportation',
//       },
//       {
//         title: 'Truck Transportation',
//         value: 'Truck Transportation',
//         key: 'Truck Transportation',
//       },
//       {
//         title: 'Warehousing and Storage',
//         value: 'Warehousing and Storage',
//         key: 'Warehousing and Storage',
//       },
//     ],
//   },
//   {
//     title: 'Wholesale',
//     value: 'Wholesale',
//     key: 'Wholesale 1',
//     children: [
//       {
//         title: 'Wholesale',
//         value: 'Wholesale',
//         key: 'Wholesale',
//       },
//       {
//         title: 'Wholesale Alcoholic Beverages',
//         value: 'Wholesale Alcoholic Beverages',
//         key: 'Wholesale Alcoholic Beverages',
//       },
//       {
//         title: 'Wholesale Apparel and Sewing Supplies',
//         value: 'Wholesale Apparel and Sewing Supplies',
//         key: 'Wholesale Apparel and Sewing Supplies',
//       },
//       {
//         title: 'Wholesale Appliances, Electrical, and Electronics',
//         value: 'Wholesale Appliances, Electrical, and Electronics',
//         key: 'Wholesale Appliances, Electrical, and Electronics',
//       },
//       {
//         title: 'Wholesale Building Materials',
//         value: 'Wholesale Building Materials',
//         key: 'Wholesale Building Materials',
//       },
//       {
//         title: 'Wholesale Chemical and Allied Products',
//         value: 'Wholesale Chemical and Allied Products',
//         key: 'Wholesale Chemical and Allied Products',
//       },
//       {
//         title: 'Wholesale Computer Equipment',
//         value: 'Wholesale Computer Equipment',
//         key: 'Wholesale Computer Equipment',
//       },
//       {
//         title: 'Wholesale Drugs and Sundries',
//         value: 'Wholesale Drugs and Sundries',
//         key: 'Wholesale Drugs and Sundries',
//       },
//       {
//         title: 'Wholesale Food and Beverage',
//         value: 'Wholesale Food and Beverage',
//         key: 'Wholesale Food and Beverage',
//       },
//       {
//         title: 'Wholesale Footwear',
//         value: 'Wholesale Footwear',
//         key: 'Wholesale Footwear',
//       },
//       {
//         title: 'Wholesale Furniture and Home Furnishings',
//         value: 'Wholesale Furniture and Home Furnishings',
//         key: 'Wholesale Furniture and Home Furnishings',
//       },
//       {
//         title: 'Wholesale Hardware, Plumbing, Heating Equipment',
//         value: 'Wholesale Hardware, Plumbing, Heating Equipment',
//         key: 'Wholesale Hardware, Plumbing, Heating Equipment',
//       },
//       {
//         title: 'Wholesale Import and Export',
//         value: 'Wholesale Import and Export',
//         key: 'Wholesale Import and Export',
//       },
//       {
//         title: 'Wholesale Luxury Goods and Jewelry',
//         value: 'Wholesale Luxury Goods and Jewelry',
//         key: 'Wholesale Luxury Goods and Jewelry',
//       },
//       {
//         title: 'Wholesale Machinery',
//         value: 'Wholesale Machinery',
//         key: 'Wholesale Machinery',
//       },
//       {
//         title: 'Wholesale Metals and Minerals',
//         value: 'Wholesale Metals and Minerals',
//         key: 'Wholesale Metals and Minerals',
//       },
//       {
//         title: 'Wholesale Motor Vehicles and Parts',
//         value: 'Wholesale Motor Vehicles and Parts',
//         key: 'Wholesale Motor Vehicles and Parts',
//       },
//       {
//         title: 'Wholesale Paper Products',
//         value: 'Wholesale Paper Products',
//         key: 'Wholesale Paper Products',
//       },
//       {
//         title: 'Wholesale Petroleum and Petroleum Products',
//         value: 'Wholesale Petroleum and Petroleum Products',
//         key: 'Wholesale Petroleum and Petroleum Products',
//       },
//       {
//         title: 'Wholesale Photography Equipment and Supplies',
//         value: 'Wholesale Photography Equipment and Supplies',
//         key: 'Wholesale Photography Equipment and Supplies',
//       },
//       {
//         title: 'Wholesale Raw Farm Products',
//         value: 'Wholesale Raw Farm Products',
//         key: 'Wholesale Raw Farm Products',
//       },
//       {
//         title: 'Wholesale Recyclable Materials',
//         value: 'Wholesale Recyclable Materials',
//         key: 'Wholesale Recyclable Materials',
//       },
//     ],
//   },
//   {
//     title: 'Additional Categories',
//     value: 'Additional Categories',
//     key: 'Additional Categories',
//     children: [
//       {
//         title: 'Animation',
//         value: 'Animation',
//         key: 'Animation',
//       },
//       {
//         title: 'Apparel and Fashion',
//         value: 'Apparel and Fashion',
//         key: 'Apparel and Fashion',
//       },
//       {
//         title: 'Arts and Crafts',
//         value: 'Arts and Crafts',
//         key: 'Arts and Crafts',
//       },
//       {
//         title: 'Automotive',
//         value: 'Automotive',
//         key: 'Automotive',
//       },
//       {
//         title: 'Aviation & Aerospace',
//         value: 'Aviation & Aerospace',
//         key: 'Aviation & Aerospace',
//       },
//       {
//         title: 'Biotechnology',
//         value: 'Biotechnology',
//         key: 'Biotechnology',
//       },
//       {
//         title: 'Building Materials',
//         value: 'Building Materials',
//         key: 'Building Materials',
//       },
//       {
//         title: 'Business Supplies and Equipment',
//         value: 'Business Supplies and Equipment',
//         key: 'Business Supplies and Equipment',
//       },
//       {
//         title: 'Commercial Real Estate',
//         value: 'Commercial Real Estate',
//         key: 'Commercial Real Estate',
//       },
//       {
//         title: 'Computer Hardware',
//         value: 'Computer Hardware',
//         key: 'Computer Hardware',
//       },
//       {
//         title: 'Computer Networking',
//         value: 'Computer Networking',
//         key: 'Computer Networking',
//       },
//       {
//         title: 'Consumer Electronics',
//         value: 'Consumer Electronics',
//         key: 'Consumer Electronics',
//       },
//       {
//         title: 'Consumer Goods',
//         value: 'Consumer Goods',
//         key: 'Consumer Goods',
//       },
//       {
//         title: 'Cosmetics',
//         value: 'Cosmetics',
//         key: 'Cosmetics',
//       },
//       {
//         title: 'Dairy',
//         value: 'Dairy',
//         key: 'Dairy',
//       },
//       {
//         title: 'Defense & Space',
//         value: 'Defense & Space',
//         key: 'Defense & Space',
//       },
//       {
//         title: 'Design',
//         value: 'Design',
//         key: 'Design',
//       },
//       {
//         title: 'E-Learning',
//         value: 'E-Learning',
//         key: 'E-Learning',
//       },
//       {
//         title: 'Education Management',
//         value: 'Education Management',
//         key: 'Education Management',
//       },
//       {
//         title: 'Entertainment',
//         value: 'Entertainment',
//         key: 'Entertainment',
//       },
//       {
//         title: 'Fine Art',
//         value: 'Fine Art',
//         key: 'Fine Art',
//       },
//       {
//         title: 'Food & Beverages',
//         value: 'Food & Beverages',
//         key: 'Food & Beverages',
//       },
//       {
//         title: 'Food Production',
//         value: 'Food Production',
//         key: 'Food Production',
//       },
//       {
//         title: 'Furniture',
//         value: 'Furniture',
//         key: 'Furniture',
//       },
//       {
//         title: 'Government Relations',
//         value: 'Government Relations',
//         key: 'Government Relations',
//       },
//       {
//         title: 'Health, Wellness and Fitness',
//         value: 'Health, Wellness and Fitness',
//         key: 'Health, Wellness and Fitness',
//       },
//       {
//         title: 'Human Resources',
//         value: 'Human Resources',
//         key: 'Human Resources',
//       },
//       {
//         title: 'Import and Export',
//         value: 'Import and Export',
//         key: 'Import and Export',
//       },
//       {
//         title: 'Industrial Automation',
//         value: 'Industrial Automation',
//         key: 'Industrial Automation',
//       },
//       {
//         title: 'Information Technology and Services',
//         value: 'Information Technology and Services',
//         key: 'Information Technology and Services',
//       },
//       {
//         title: 'Leisure, Travel & Tourism',
//         value: 'Leisure, Travel & Tourism',
//         key: 'Leisure, Travel & Tourism',
//       },
//       {
//         title: 'Luxury Goods and Jewelry',
//         value: 'Luxury Goods and Jewelry',
//         key: 'Luxury Goods and Jewelry',
//       },
//       {
//         title: 'Maritime',
//         value: 'Maritime',
//         key: 'Maritime',
//       },
//       {
//         title: 'Mechanical or Industrial Engineering',
//         value: 'Mechanical or Industrial Engineering',
//         key: 'Mechanical or Industrial Engineering',
//       },
//       {
//         title: 'Medical Devices',
//         value: 'Medical Devices',
//         key: 'Medical Devices',
//       },
//       {
//         title: 'Music',
//         value: 'Music',
//         key: 'Music',
//       },
//       {
//         title: 'Non-profit Organization Management',
//         value: 'Non-profit Organization Management',
//         key: 'Non-profit Organization Management',
//       },
//       {
//         title: 'Online Media',
//         value: 'Online Media',
//         key: 'Online Media',
//       },
//       {
//         title: 'Outsourcing/Offshoring',
//         value: 'Outsourcing/Offshoring',
//         key: 'Outsourcing/Offshoring',
//       },
//       {
//         title: 'Packaging and Containers',
//         value: 'Packaging and Containers',
//         key: 'Packaging and Containers',
//       },
//       {
//         title: 'Paper and Forest Products',
//         value: 'Paper and Forest Products',
//         key: 'Paper and Forest Products',
//       },
//       {
//         title: 'Philanthropy',
//         value: 'Philanthropy',
//         key: 'Philanthropy',
//       },
//       {
//         title: 'Program Development',
//         value: 'Program Development',
//         key: 'Program Development',
//       },
//       {
//         title: 'Public Policy',
//         value: 'Public Policy',
//         key: 'Public Policy',
//       },
//       {
//         title: 'Renewables & Environment',
//         value: 'Renewables & Environment',
//         key: 'Renewables & Environment',
//       },
//       {
//         title: 'Research',
//         value: 'Research',
//         key: 'Research',
//       },
//       {
//         title: 'Semiconductors',
//         value: 'Semiconductors',
//         key: 'Semiconductors',
//       },
//       {
//         title: 'Sporting Goods',
//         value: 'Sporting Goods',
//         key: 'Sporting Goods',
//       },
//       {
//         title: 'Tobacco',
//         value: 'Tobacco',
//         key: 'Tobacco',
//       },
//       {
//         title: 'Transportation/Trucking/Railroad',
//         value: 'Transportation/Trucking/Railroad',
//         key: 'Transportation/Trucking/Railroad',
//       },
//       {
//         title: 'Veterinary',
//         value: 'Veterinary',
//         key: 'Veterinary',
//       },
//       {
//         title: 'Warehousing',
//         value: 'Warehousing',
//         key: 'Warehousing',
//       },
//       {
//         title: 'Wine and Spirits',
//         value: 'Wine and Spirits',
//         key: 'Wine and Spirits',
//       },
//     ],
//   },
// ]

// Continent/region grouping for LINKEDIN_COUNTRIES — used to nest the
// People-country filter (agent-os/outbound/people-filter-panel.tsx) into
// expandable regions, since LINKEDIN_COUNTRIES itself is a flat list with no
// region metadata. Any country not present here (e.g. a future addition to
// LINKEDIN_COUNTRIES) falls back to an "Other" bucket at the call site
// rather than silently disappearing from the filter.
export const LINKEDIN_COUNTRY_REGIONS: Record<string, string> = {
  "United States": "North America",
  Bermuda: "North America",
  Canada: "North America",
  Greenland: "North America",
  Mexico: "North America",
  "Saint Pierre and Miquelon": "North America",

  Anguilla: "Caribbean",
  "Antigua and Barbuda": "Caribbean",
  Aruba: "Caribbean",
  Bahamas: "Caribbean",
  Barbados: "Caribbean",
  "Cayman Islands": "Caribbean",
  "Caribbean Nations": "Caribbean",
  Cuba: "Caribbean",
  Dominica: "Caribbean",
  "Dominican Republic": "Caribbean",
  Grenada: "Caribbean",
  Guadeloupe: "Caribbean",
  Haiti: "Caribbean",
  Jamaica: "Caribbean",
  Martinique: "Caribbean",
  Montserrat: "Caribbean",
  "Netherlands Antilles": "Caribbean",
  "Puerto Rico": "Caribbean",
  "Saint Kitts and Nevis": "Caribbean",
  "Saint Lucia": "Caribbean",
  "Saint Vincent and the Grenadines": "Caribbean",
  "Trinidad and Tobago": "Caribbean",
  "Turks and Caicos Islands": "Caribbean",
  "Virgin Islands (British)": "Caribbean",
  "Virgin Islands (U.S.)": "Caribbean",

  Belize: "Central America",
  "Costa Rica": "Central America",
  "El Salvador": "Central America",
  Guatemala: "Central America",
  Honduras: "Central America",
  Nicaragua: "Central America",
  Panama: "Central America",

  Argentina: "South America",
  Bolivia: "South America",
  Brazil: "South America",
  Chile: "South America",
  Colombia: "South America",
  Ecuador: "South America",
  "Falkland Islands (Malvinas)": "South America",
  "French Guiana": "South America",
  Guyana: "South America",
  Paraguay: "South America",
  Peru: "South America",
  Suriname: "South America",
  Uruguay: "South America",
  Venezuela: "South America",

  "Aland Islands": "Europe",
  Albania: "Europe",
  Andorra: "Europe",
  Austria: "Europe",
  Belarus: "Europe",
  Belgium: "Europe",
  "Bosnia and Herzegovina": "Europe",
  Bulgaria: "Europe",
  Croatia: "Europe",
  Cyprus: "Europe",
  "Czech Republic": "Europe",
  Denmark: "Europe",
  Estonia: "Europe",
  "Faroe Islands": "Europe",
  Finland: "Europe",
  France: "Europe",
  Germany: "Europe",
  Gibraltar: "Europe",
  Greece: "Europe",
  Guernsey: "Europe",
  Hungary: "Europe",
  Iceland: "Europe",
  Ireland: "Europe",
  "Isle of Man": "Europe",
  Italy: "Europe",
  Jersey: "Europe",
  Latvia: "Europe",
  Liechtenstein: "Europe",
  Lithuania: "Europe",
  Luxembourg: "Europe",
  Macedonia: "Europe",
  Malta: "Europe",
  Moldova: "Europe",
  Monaco: "Europe",
  Montenegro: "Europe",
  Netherlands: "Europe",
  Norway: "Europe",
  Poland: "Europe",
  Portugal: "Europe",
  Romania: "Europe",
  "Russian Federation": "Europe",
  "San Marino": "Europe",
  Serbia: "Europe",
  "Slovak Republic": "Europe",
  Slovenia: "Europe",
  Spain: "Europe",
  "Svalbard and Jan Mayen": "Europe",
  Sweden: "Europe",
  Switzerland: "Europe",
  Ukraine: "Europe",
  "United Kingdom": "Europe",
  "Vatican City State (Holy See)": "Europe",

  Armenia: "Middle East",
  Azerbaijan: "Middle East",
  Bahrain: "Middle East",
  Georgia: "Middle East",
  Iran: "Middle East",
  Iraq: "Middle East",
  Israel: "Middle East",
  Jordan: "Middle East",
  Kuwait: "Middle East",
  Lebanon: "Middle East",
  Oman: "Middle East",
  "Palestinian Territory": "Middle East",
  Qatar: "Middle East",
  "Saudi Arabia": "Middle East",
  Syria: "Middle East",
  Turkey: "Middle East",
  "United Arab Emirates": "Middle East",
  Yemen: "Middle East",

  Algeria: "Africa",
  Angola: "Africa",
  Benin: "Africa",
  Botswana: "Africa",
  "Burkina Faso": "Africa",
  Burundi: "Africa",
  Cameroon: "Africa",
  "Cape Verde": "Africa",
  "Central African Republic": "Africa",
  Chad: "Africa",
  Comoros: "Africa",
  Congo: "Africa",
  "Cote D’Ivoire (Ivory Coast)": "Africa",
  "Democratic Republic of the Congo": "Africa",
  Djibouti: "Africa",
  Egypt: "Africa",
  "Equatorial Guinea": "Africa",
  Eritrea: "Africa",
  Ethiopia: "Africa",
  Gabon: "Africa",
  Gambia: "Africa",
  Ghana: "Africa",
  Guinea: "Africa",
  "Guinea-Bissau": "Africa",
  Kenya: "Africa",
  Lesotho: "Africa",
  Liberia: "Africa",
  Libya: "Africa",
  Madagascar: "Africa",
  Malawi: "Africa",
  Mali: "Africa",
  Mauritania: "Africa",
  Mauritius: "Africa",
  Mayotte: "Africa",
  Morocco: "Africa",
  Mozambique: "Africa",
  Namibia: "Africa",
  Niger: "Africa",
  Nigeria: "Africa",
  Reunion: "Africa",
  Rwanda: "Africa",
  "Saint Helena": "Africa",
  "Sao Tome and Principe": "Africa",
  Senegal: "Africa",
  Seychelles: "Africa",
  "Sierra Leone": "Africa",
  Somalia: "Africa",
  "South Africa": "Africa",
  Sudan: "Africa",
  Swaziland: "Africa",
  Tanzania: "Africa",
  Togo: "Africa",
  Tunisia: "Africa",
  Uganda: "Africa",
  "Western Sahara": "Africa",
  Zambia: "Africa",
  Zimbabwe: "Africa",

  Afghanistan: "Asia",
  Bangladesh: "Asia",
  Bhutan: "Asia",
  "British Indian Ocean Territory": "Asia",
  "Brunei Darussalam": "Asia",
  Cambodia: "Asia",
  China: "Asia",
  "East Timor": "Asia",
  "Hong Kong": "Asia",
  India: "Asia",
  Indonesia: "Asia",
  Japan: "Asia",
  Kazakhstan: "Asia",
  Korea: "Asia",
  "Korea (North)": "Asia",
  Kyrgyzstan: "Asia",
  Laos: "Asia",
  Macao: "Asia",
  Malaysia: "Asia",
  Maldives: "Asia",
  Mongolia: "Asia",
  Myanmar: "Asia",
  Nepal: "Asia",
  Pakistan: "Asia",
  Philippines: "Asia",
  Singapore: "Asia",
  "Sri Lanka": "Asia",
  Taiwan: "Asia",
  Tajikistan: "Asia",
  Thailand: "Asia",
  "Timor-Leste": "Asia",
  Turkmenistan: "Asia",
  Uzbekistan: "Asia",
  Vietnam: "Asia",

  "American Samoa": "Oceania",
  Australia: "Oceania",
  "Christmas Island": "Oceania",
  "Cocos (Keeling) Islands": "Oceania",
  "Cook Islands": "Oceania",
  Fiji: "Oceania",
  "Federated States of Micronesia": "Oceania",
  "French Polynesia": "Oceania",
  "French Southern Territories": "Oceania",
  Guam: "Oceania",
  Kiribati: "Oceania",
  "Marshall Islands": "Oceania",
  Nauru: "Oceania",
  "New Caledonia": "Oceania",
  "New Zealand": "Oceania",
  Niue: "Oceania",
  "Norfolk Island": "Oceania",
  "Northern Mariana Islands": "Oceania",
  Palau: "Oceania",
  "Papua New Guinea": "Oceania",
  Pitcairn: "Oceania",
  Samoa: "Oceania",
  "Solomon Islands": "Oceania",
  Tokelau: "Oceania",
  Tonga: "Oceania",
  Tuvalu: "Oceania",
  Vanuatu: "Oceania",
  "Wallis and Futuna": "Oceania",

  Antarctica: "Other",
  Other: "Other"
}
